controller = require('../components/fee_calculator/fee_calculator_controller')

angular.module('wbControllers').controller 'FeeCalculatorController', controller